// Normalizes the many backend policy/revision statuses into the six states
// the tracker UI actually renders.
export type TrackerState = "in_review" | "approved" | "active" | "rejected" | "expired" | "cancelled";

const REJECTED = ["REJECTED", "DECLINED", "EXTERNAL_REJECTED", "EXTERNAL_DECLINED"];
const EXPIRED = ["EXPIRED", "EXTERNAL_EXPIRED"];
const CANCELLED = ["CANCELLED", "INACTIVE", "EXTERNAL_CANCELLED", "EXTERNAL_INACTIVE"];
const ACTIVE = ["ACTIVE", "EXTERNAL_ACTIVE"];
const APPROVED = ["APPROVED", "EXTERNAL_APPROVED", "EXTERNAL_VERIFIED", "SCHEDULED"];

export function normalizeStatus(status: string | null | undefined): TrackerState {
  const s = (status || "").toUpperCase().replace(/ /g, "_");
  if (REJECTED.includes(s)) return "rejected";
  if (EXPIRED.includes(s)) return "expired";
  if (CANCELLED.includes(s)) return "cancelled";
  if (ACTIVE.includes(s)) return "active";
  if (APPROVED.includes(s)) return "approved";
  return "in_review";
}

export const StateBadge: Record<TrackerState, { label: string; className: string }> = {
  in_review: { label: "Under review", className: "badge--review" },
  approved: { label: "Approved", className: "badge--approved" },
  active: { label: "Active", className: "badge--active" },
  rejected: { label: "Rejected", className: "badge--rejected" },
  expired: { label: "Expired", className: "badge--expired" },
  cancelled: { label: "Cancelled", className: "badge--cancelled" },
};
